export type JinglesListPageTabsKeys = 'jingle' | 'jinglecollection'
export const JinglesListPageTabsKeysEnum: Record<
  JinglesListPageTabsKeys,
  JinglesListPageTabsKeys
> = {
  jingle: 'jingle',
  jinglecollection: 'jinglecollection',
} as const
export const DEFAULT_JINGLES_LIST_PAGE_TAB: JinglesListPageTabsKeys = 'jingle'
const JinglesListPageTabsArray: JinglesListPageTabsKeys[] = [
  'jingle',
  'jinglecollection',
]
export const isJinglesListPageTab = (
  tab: string,
): tab is JinglesListPageTabsKeys =>
  JinglesListPageTabsArray.includes(tab as JinglesListPageTabsKeys)
export const JinglesListPageTabsKeysArray: JinglesListPageTabsKeys[] = [
  'jingle',
  'jinglecollection',
]
